import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=1fc96348&"
import script from "./Textfield.vue?vue&type=script&lang=ts&"
export * from "./Textfield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "59ab87ee"
  
)

export default component.exports